var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-block"},[_c('div',{staticClass:"loader-svg-block"},[_c('lottie',{attrs:{"options":_vm.defaultOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }